import React, { Component } from "react";
import { Routes, Route, Outlet, Link } from "react-router-dom";

import CalendarPage from "./Calender";
import Event from "./Event";
import EditEvent from "./EditEvent";
import CloneEvent from "./CloneEvent";
import CreateEvent from "./CreateEvent";
import EventChoice from "./EventChoice";
import {AuthComponents} from "../../lib/_sso";

export default class EventPages extends Component {
  render() {
    return (
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<CalendarPage />} />
          <Route path="/create" element={<CreateEvent />} />
          <Route path="/event/:event_id/clone" element={<CloneEvent />} />
          <Route path="/event/:event_id/edit" element={<EditEvent />} />
          <Route path="/picker" element={<EventChoice />} />
          <Route path="/event/:event_id" element={<Event />} />
          <Route path="*" element={<NoMatch2 />} />
        </Route>
      </Routes>
    );
  }
}
function Layout() {
  const scope = ["events:read"];

  return (
    <div className="min-h-full">
      <main>
        <AuthComponents.Can scope={scope}>
          <Outlet />
        </AuthComponents.Can>
        <AuthComponents.CanNot scope={scope}>
          <div className={"p-2 text-red-500"}>Access Denied: You do not have permission to access this page.</div>
        </AuthComponents.CanNot>
      </main>
    </div>
  );
}
function NoMatch2() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </div>
  );
}
